module.exports = __webpack_public_path__ + "images/knmv_small65e497001f0d20df896d876866e45bee.png";